import type { AgencyCategory } from '@saaga/shared/interfaces/agencies.interface'
import type { AgentEdge, AgentNode } from '@saaga/shared/interfaces/agency-node.interface'
import type { AgentTool } from '@saaga/shared/interfaces/agent-tool.interface'
import type { LlmModel } from '@saaga/shared/interfaces/llm-model.interface'
import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'
import { AgencyFlowCanvas } from '@/components/agencies/agency-flow/agency-flow-canvas.organism'
import { AgencyForm } from '@/components/agencies/agency-form.organism'
import type { AgencyFormSchemaType } from '@/components/agencies/agency-form.schema'
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from '@/components/ui/resizable'

interface AgencyFormPanelsViewProps {
  form: UseFormReturn<AgencyFormSchemaType>
  categoryList: AgencyCategory[]
  logoPreviewUrl: string | null
  onLogoChange: (file: File | null) => void
  onLogoRemove: () => void
  isDisabled: boolean
  agencySlug?: string
  modelList: LlmModel[]
  isLoadingModels: boolean
  toolList: AgentTool[]
  isLoadingTools: boolean
  onFlowChange: (nodeList: AgentNode[], edgeList: AgentEdge[]) => void
  canvasKey?: number
  initialNodeList?: AgentNode[]
  initialEdgeList?: AgentEdge[]
  onExport: () => void
  onImport: (file: File) => void
}

export const AgencyFormPanelsView = (props: AgencyFormPanelsViewProps): ReactNode => (
  <ResizablePanelGroup className="agency-create-edit-panels flex-1">
    <ResizablePanel
      defaultSize={50}
      minSize={30}
      className="agency-create-edit-form-panel overflow-hidden"
    >
      <AgencyForm
        form={props.form}
        categoryList={props.categoryList}
        logoPreviewUrl={props.logoPreviewUrl}
        onLogoChange={props.onLogoChange}
        onLogoRemove={props.onLogoRemove}
        isDisabled={props.isDisabled}
        agencySlug={props.agencySlug}
      />
    </ResizablePanel>
    <ResizableHandle withHandle />
    <ResizablePanel defaultSize={50} minSize={30} className="agency-create-edit-config-panel">
      <AgencyFlowCanvas
        key={props.canvasKey}
        className="agency-flow-editor"
        onChange={props.onFlowChange}
        modelList={props.modelList}
        isLoadingModels={props.isLoadingModels}
        toolList={props.toolList}
        isLoadingTools={props.isLoadingTools}
        initialNodeList={props.initialNodeList}
        initialEdgeList={props.initialEdgeList}
        onExport={props.onExport}
        onImport={props.onImport}
      />
    </ResizablePanel>
  </ResizablePanelGroup>
)
